import { BaseApi } from "../BaseApi";

const buscarMedicamentosUrl =
  "/api/v1/websalud/primeraars/ordsinfoplan/productos/medicamentos";
const obtenerEspecialidadesMedicasUrl =
  "/api/v1/websalud/primeraars/ordsinfoplan/especialidades-medicas";

const buscarMedicamentos = (request) => {
  const { descripcion, offset, limit, numeroSesion } = request;

  const queryObject = {
    descripcion: {
      $like: `${descripcion}%`,
    },
  };

  const queryString = JSON.stringify(queryObject);

  let url = `${buscarMedicamentosUrl}?q=${queryString}`;

  if (offset !== undefined) {
    url += `&offset=${offset}`;
  }

  if (limit !== undefined) {
    url += `&limit=${limit}`;
  }

  const headers = {};

  if (numeroSesion) {
    headers["x-numero-sesion"] = numeroSesion;
  }

  return BaseApi.get(url).then((response) => response.data);
};

const obtenerEspecialidadesMedicas = (request) => {
  const { offset, limit = 25 } = request || {};

  const queryObject = {
    $orderby: {
      descripcion: "asc",
    },
  };

  const queryString = JSON.stringify(queryObject);

  let url = `${obtenerEspecialidadesMedicasUrl}?q=${queryString}`;

  if (offset !== undefined) {
    url += `&offset=${offset}`;
  }

  // limit siempre se incluye con valor por defecto de 25
  url += `&limit=${limit}`;

  return BaseApi.get(url).then((response) => response.data);
};

const exportedObject = {
  buscarMedicamentos,
  obtenerEspecialidadesMedicas,
};

export default exportedObject;
